// Localize storefront app labels that do not follow Shopify's active language.
(function () {
  var lang = document.documentElement.lang.split('-')[0];
  var labels = {
    fr: ['Partager ce panier', 'Utilisez ce lien pour partager votre panier', 'Partager sur', 'Copier le lien', 'Fermer', 'Liste de souhaits', 'Choisir une option', 'Produit suivant'],
    de: ['Warenkorb teilen', 'Teilen Sie Ihren Warenkorb mit diesem Link', 'Teilen auf', 'Link kopieren', 'Schließen', 'Wunschliste', 'Option auswählen', 'Nächstes Produkt'],
    nl: ['Winkelwagen delen', 'Gebruik deze link om je winkelwagen te delen', 'Delen via', 'Link kopiëren', 'Sluiten', 'Verlanglijst', 'Kies een optie', 'Volgend product']
  }[lang];
  if (!labels) return;
  function translate() {
    document.querySelectorAll('.Avada-BundleBuilder a[href^="/products/"]').forEach(function (el) {
      el.setAttribute('href', '/' + lang + el.getAttribute('href'));
    });
    document.querySelectorAll('.Avada-BundleCategory__badge, .Avada-BundleSummary__ValidationMessage').forEach(function (el) {
      var words = {fr: ['article', 'articles'], de: ['Artikel', 'Artikel'], nl: ['artikel', 'artikelen']}[lang];
      var translated = el.textContent.replace(/\bitems\b/g, words[1]).replace(/\bitem\b/g, words[0]);
      if (translated !== el.textContent) el.textContent = translated;
    });
    var textSelectors = ['.moonloon-share-cart-button a', '#mmc-share-cart-modal .mmc-modal-title', '#mmc-share-cart-modal .mmc-social-links__share-label'];
    textSelectors.forEach(function (selector, i) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.textContent.trim() !== labels[i]) el.textContent = labels[i];
      });
    });
    ['#mmc-share-cart-copy', '#mmc-share-cart-modal-close'].forEach(function (selector, i) {
      var el = document.querySelector(selector);
      if (el) el.setAttribute('aria-label', labels[i + 3]);
    });
    ['Wishlist page link', 'Select option', 'Next product'].forEach(function (original, i) {
      document.querySelectorAll('[aria-label="' + original + '"]').forEach(function (el) {
        el.setAttribute('aria-label', labels[i + 5]);
      });
    });
  }
  function start() {
    translate();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; translate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


// Keep Share Cart links in the language in which the customer created them.
// Only the app's successful create_cart response is adjusted; cart data is untouched.
(function () {
  if (window.__ggShareCartLocale || !window.fetch) return;
  window.__ggShareCartLocale = true;
  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var args = arguments;
    var requestUrl;
    try {
      requestUrl = new URL(typeof input === 'string' ? input : input.url || String(input), location.href);
    } catch (_) { return originalFetch.apply(this, args); }
    if (requestUrl.origin !== location.origin || !/^\/(?:fr\/|de\/|nl\/)?apps\/share-cart-app\/create_cart\/?$/.test(requestUrl.pathname)) {
      return originalFetch.apply(this, args);
    }
    var lang = document.documentElement.lang.split('-')[0];
    if (!['fr', 'de', 'nl'].includes(lang)) return originalFetch.apply(this, args);
    return originalFetch.apply(this, args).then(async function (response) {
      if (!response.ok) return response;
      try {
        var data = await response.clone().json();
        if (typeof data.link !== 'string') return response;
        var link = new URL(data.link, location.origin);
        if (link.origin !== location.origin || !/^\/(?:fr\/|de\/|nl\/)?cart\/?$/.test(link.pathname) || !link.searchParams.has('ml-shared-cart-id')) return response;
        var oldLink = data.link;
        link.pathname = '/' + lang + '/cart/';
        data.link = link.href;
        if (typeof data.mailBody === 'string') {
          data.mailBody = data.mailBody.split(oldLink).join(data.link).split(encodeURIComponent(oldLink)).join(encodeURIComponent(data.link));
        }
        var headers = new Headers(response.headers);
        headers.delete('content-length');
        headers.delete('content-encoding');
        return new Response(JSON.stringify(data), {status: response.status, statusText: response.statusText, headers: headers});
      } catch (_) { return response; }
    });
  };
})();

